const INTERACTIVE_TARGET_SELECTOR =
  "a, button, input, textarea, select, [role='button'], [data-card-action-stop]";

/**
 * Проверяет, должен ли клик внутри settings card остаться локальным действием.
 * Root card может сама иметь role="button", поэтому ее нужно исключить из guard.
 * @param {Element|null} target - DOM-цель события
 * @param {Element|null} rootElement - Корневой элемент карточки
 * @returns {boolean}
 */
export const isSettingsCardInteractiveTarget = (
  target,
  rootElement
) => {
  const interactiveTarget = target?.closest?.(
    INTERACTIVE_TARGET_SELECTOR
  );

  return Boolean(interactiveTarget && interactiveTarget !== rootElement);
};
